import Tab from '@material-ui/core/Tab'
import { withStyles } from '@material-ui/core'

const StyledTab = withStyles({})(Tab)

export default StyledTab
